export interface SaveAdvertNoteDTO {
  note: string;
  // the contact of the user who created the history record
  contactId: string;
  reminderDateTime?: Date;
}
